import { Injectable, NgZone } from "@angular/core";
import { Subject } from "rxjs";
import { Credentials } from "./bridge.service";

@Injectable({
  providedIn: 'root'
})
export class BridgeInputService {

  newScanDoc$ = new Subject<any>();
  logout$ = new Subject<any>();
  credentials$ = new Subject<Credentials>();

  constructor(private ngZone: NgZone) {

  }

  newScanDocFromNative(encodedFile64: string) {
    this.newScanDoc$.next(encodedFile64);
  }

  logoutFromNative(logout: boolean) {
    this.ngZone.run(() => {
      this.logout$.next(logout);
    });
  }

  passCredentials(credentialsJson: string) {
    this.ngZone.run(() => {
      try {
        const credentials: Credentials = JSON.parse(credentialsJson)
        this.credentials$.next(credentials);
      } catch (error) {
        console.error('passCredentials: cannot be parsed');
      }
    });
  }
}
